import { JoyXStatusBlock, JoyYStatusBlock, ButtonStatusBlock } from "../assemblyBlocks/inputBlocks";
import { MakeControlElementBlock } from "../assemblyBlocks/inputBlocks/MakeControlElementBlock";
import { ConsoleLogBlock } from "../assemblyBlocks/outputBlocks/ConsoleLogBlock";
import { EQBlock, GEQBlock, GTBlock, LTBlock, LEQBlock } from "../assemblyBlocks/returnBlocks/boolean/comparison";
import { ANDBlock, NOTBlock, ORBlock } from "../assemblyBlocks/returnBlocks/boolean/operators";
import { DivisionBlock, ExponentBlock, ModuloBlock, ProductBlock, SubtractBlock, SumBlock } from "../assemblyBlocks/returnBlocks/math";
import { TernaryBlock } from "../assemblyBlocks/returnBlocks/TernaryBlock";
import { GetXBlock, GetYBlock, MoveBlock, RotateBlock, ScaleBlock } from "../assemblyBlocks/shape";
import { GetShapeBlock } from "../assemblyBlocks/shape/GetShapeBlock";
import { MakeShapeBlock } from "../assemblyBlocks/shape/MakeShapeBlock";
import { WHILEBlock, IFBlock, FORBlock } from "../assemblyBlocks/specialBlocks";
import { ArrayGetIndex, ArraySetIndex, ConstBlock, VarAssignBlock, VarDeleteBlock, VarRetrieveBlock } from "../assemblyBlocks/variable";
import { ArrayCreateBlock } from "../assemblyBlocks/variable/ArrayCreateBlock";

import { BlockType } from "./BlockType";

// todo organize imports with index.ts files


/**
 * Factory for blocks. In JS because this would be really hard to to in TS :/
 * @param {string} id the id of the corresponding state node.
 * @param {BlockType} type type of block being created
 * @param  {...any} inputs vararg inputs
 * @returns {AbstractBlock} the constructed AbstractBlock from type and inputs.
 */
export function createAssemblyBlock(id, type, ...inputs) {
    let a, b, c, d, e; // declared because of scope limitations

    switch (type) {
        case BlockType.CLB:
            [a] = inputs;
            return new ConsoleLogBlock(id, a); // inputs
        case BlockType.SUM:
            [a] = inputs;
            return new SumBlock(id, a); // inputs
        case BlockType.PROD:
            [a] = inputs;
            return new ProductBlock(id, a); //inputs
        case BlockType.SUBTRACT:
            [a] = inputs;
            return new SubtractBlock(id, a); //inputs
        case BlockType.MOD:
            [a] = inputs;
            return new ModuloBlock(id, a);
        case BlockType.EXP:
            [a] = inputs;
            return new ExponentBlock(id, a);
        case BlockType.DIV:
            [a] = inputs;
            return new DivisionBlock(id, a);
        case BlockType.CONST:
            [a] = inputs;
            return new ConstBlock(id, a); // value
        case BlockType.VAR_ASSIGN:
            [a, b] = inputs;
            return new VarAssignBlock(id, a, b); // name, value
        case BlockType.VAR_RETRIEVE:
            [a] = inputs;
            return new VarRetrieveBlock(id, a); // name
        case BlockType.DELETE:
            [a] = inputs;
            return new VarDeleteBlock(id, a); // name
        case BlockType.TERNARY:
            [a] = inputs;
            return new TernaryBlock(id, a); // inputs
        case BlockType.AND:
            [a] = inputs;
            return new ANDBlock(id, a);
        case BlockType.OR:
            [a] = inputs;
            return new ORBlock(id, a);
        case BlockType.NOT:
            [a] = inputs;
            return new NOTBlock(id, a);
        case BlockType.EQ:
            [a] = inputs;
            return new EQBlock(id, a);
        case BlockType.GEQ:
            [a] = inputs;
            return new GEQBlock(id, a);
        case BlockType.GT:
            [a] = inputs;
            return new GTBlock(id, a);
        case BlockType.LEQ:
            [a] = inputs;
            return new LEQBlock(id, a);
        case BlockType.LT:
            [a] = inputs;
            return new LTBlock(id, a);
        case BlockType.WHILE:
            [[a, b]] = inputs;
            return new WHILEBlock(id, a, b); // conditions, blocks
        case BlockType.IF:
            console.log(inputs);
            [[a, b, c]] = inputs;
            console.log(a);
            console.log(b);
            console.log(c);
            return new IFBlock(id, a, b, c); // condition, then, otherwise
        case BlockType.FOR:
            [a, b, c, d, e] = inputs;
            return new FORBlock(id, a, b, c, d, e); // counter name, init val, condition, incr value, nodes
        case BlockType.MAKE_SHAPE:
            [a, b, c] = inputs;
            return new MakeShapeBlock(id, a, b, c);
        case BlockType.MOVE_SHAPE:
            [a] = inputs;
            return new MoveBlock(id, a);
        case BlockType.SCALE_SHAPE:
            [a] = inputs;
            return new ScaleBlock(id, a);
        case BlockType.ROTATE_SHAPE:
            [a] = inputs;
            return new RotateBlock(id, a);
        case BlockType.GET_SHAPE:
            [a] = inputs;
            return new GetShapeBlock(id, a);
        case BlockType.JOY_X:
            [a] = inputs;
            return new JoyXStatusBlock(id, a); //name
        case BlockType.JOY_Y:
            [a] = inputs;
            return new JoyYStatusBlock(id, a); //name
        case BlockType.BTN_STATUS:
            [a] = inputs;
            return new ButtonStatusBlock(id, a); //name
        case BlockType.ARR_CREATE:
            [a] = inputs;
            return new ArrayCreateBlock(id, a);
        case BlockType.ARR_SET_IX:
            [a, b] = inputs;
            return new ArraySetIndex(id, a, b);
        case BlockType.ARR_GET_IX:
            [a, b] = inputs;
            return new ArrayGetIndex(id, a, b);
        case BlockType.MAKE_CONTROL_ELEM:
            [a, b, c] = inputs;
            return new MakeControlElementBlock(id, a, b, c);
        case BlockType.GET_X:
            [a] = inputs;
            return new GetXBlock(id, a);
        case BlockType.GET_Y:
            [a] = inputs;
            return new GetYBlock(id, a);
        default:
            throw new EvalError('Entered BlockType is not yet supported in BlockFactory');
    }
}